import React, { useEffect, useState, useCallback } from 'react';
import {
  fetchDeleteRequests,
  sendDeletionConfirmationMail,
  approveDeleteRequest,
  rejectDeleteRequest
} from '../api/actions/authactions';
import './deleteAccount.css';

const TABS = ['PENDING', 'EMAIL_SENT', 'CONFIRMED', 'APPROVED', 'REJECTED', ''];
const TAB_LABEL = {
  PENDING: 'New',
  EMAIL_SENT: 'Mail sent',
  CONFIRMED: 'Driver confirmed',
  APPROVED: 'Deleted',
  REJECTED: 'Rejected',
  '': 'All'
};

export default function DeleteRequests() {
  const [status, setStatus] = useState('PENDING');
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [busyId, setBusyId] = useState(null);

  const getToken = async () => localStorage.getItem('token');

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetchDeleteRequests(await getToken(), status);
      setRows(res.success ? res.data : []);
    } catch (e) {
      setRows([]);
    }
    setLoading(false);
  }, [status]);

  useEffect(() => { load(); }, [load]);

  const act = async (id, action) => {
    const confirmText = {
      send: 'Send the confirmation mail to this driver?',
      approve: 'Permanently delete this driver account? This cannot be undone.',
      reject: 'Reject this deletion request?'
    }[action];
    if (!window.confirm(confirmText)) return;

    setBusyId(id);
    try {
      const token = await getToken();
      const fn = { send: sendDeletionConfirmationMail, approve: approveDeleteRequest, reject: rejectDeleteRequest }[action];
      const res = await fn(token, id);
      if (!res.success) alert(res.message || 'Action failed');
    } catch (e) {
      alert('Network error');
    }
    setBusyId(null);
    load();
  };

  return (
    <div className="dr-wrap">
      <div className="dr-head">
        <h2>Account deletion requests</h2>
        <div className="dr-tabs">
          {TABS.map((t) => (
            <button key={t || 'all'} className={status === t ? 'active' : ''} onClick={() => setStatus(t)}>
              {TAB_LABEL[t]}
            </button>
          ))}
        </div>
      </div>

      <table className="dr-table">
        <thead>
          <tr>
            <th>ID</th><th>User ID</th><th>Driver</th><th>Mobile</th>
            <th>Reason</th><th>Status</th><th>Requested</th><th>Action</th>
          </tr>
        </thead>
        <tbody>
          {loading && <tr><td colSpan={8}>Loading...</td></tr>}
          {!loading && rows.length === 0 && <tr><td colSpan={8}>No requests</td></tr>}
          {rows.map((r) => (
            <tr key={r._id}>
              <td title={r._id}>{String(r._id).slice(-6)}</td>
              <td>{r.userId}</td>
              <td>{r.user ? `${r.user.firstName || ''} ${r.user.lastName || ''}` : '— (removed)'}</td>
              <td>{r.user ? r.user.mobile : '—'}</td>
              <td>{r.reason || '—'}</td>
              <td><span className={`dr-badge ${r.status.toLowerCase()}`}>{TAB_LABEL[r.status] || r.status}</span></td>
              <td>{new Date(r.createdAt).toLocaleString()}</td>
              <td className="dr-actions">
                {(r.status === 'PENDING' || r.status === 'EMAIL_SENT') && (
                  <button className="send" disabled={busyId === r._id} onClick={() => act(r._id, 'send')}>
                    {r.status === 'PENDING' ? 'Send mail' : 'Resend mail'}
                  </button>
                )}
                {r.status === 'CONFIRMED' && (
                  <button className="approve" disabled={busyId === r._id} onClick={() => act(r._id, 'approve')}>
                    Delete
                  </button>
                )}
                {['PENDING', 'EMAIL_SENT', 'CONFIRMED'].includes(r.status) && (
                  <button className="reject" disabled={busyId === r._id} onClick={() => act(r._id, 'reject')}>
                    Reject
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}